import _extends from "@babel/runtime/helpers/esm/extends";

/**
 * @file 下拉筛选项
 * @author alfielv
 */
import React, { useCallback } from 'react';
import classnames from 'classnames';
import { Select } from '@tencent/spaui';
import { PREFIX_CLS } from '../../../../constants';
var prefixCls = "".concat(PREFIX_CLS, "-listview");
export default (function (props) {
  var config = props.config,
      _props$value = props.value,
      value = _props$value === void 0 ? '' : _props$value,
      onChange = props.onChange,
      setActive = props.setActive;

  var _ref = config || {},
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      onChangeOfConfig = _ref.onChange,
      onOpenFromConfig = _ref.onOpen;

  var handleChange = useCallback(function (event, value, valueMap) {
    onChangeOfConfig === null || onChangeOfConfig === void 0 ? void 0 : onChangeOfConfig(event, value, valueMap);
    onChange(value);
  }, [onChange, onChangeOfConfig]);
  var handleOpen = useCallback(function (event, open) {
    onOpenFromConfig === null || onOpenFromConfig === void 0 ? void 0 : onOpenFromConfig(event, open);
    setActive === null || setActive === void 0 ? void 0 : setActive(open);
  }, [setActive, onOpenFromConfig]);
  return /*#__PURE__*/React.createElement(Select, _extends({
    placeholder: "\u8BF7\u9009\u62E9\u7B5B\u9009\u6761\u4EF6",
    mountTarget: "body"
  }, config, {
    className: classnames("".concat(prefixCls, "__select"), className),
    value: value,
    onChange: handleChange,
    onOpen: handleOpen
  }));
});